import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import HttpCodeMessage from 'shared_components/message_http_status';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchPhysicianItems() {
	let physicianItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: 'settings/physician',
		});

		const { data } = response;
		physicianItems = data.RECORDS;
	} catch (e) {
		showMessage(e);
	}

	return physicianItems;
}

export async function createPhysicianItems(payload) {
	let createdPhysician;

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: 'settings/physician',
			data: {
				p_physician_prefix: payload.physicianPrefix,
				p_physician_first_name: payload.physicianFirstName,
				p_physician_middle_name: payload.physicianMiddleName,
				p_physician_last_name: payload.physicianLastName,
				p_physician_suffix: payload.physicianSuffix,
				p_physician_degree: payload.physicianDegree,
				p_physician_license_no: payload.physicianLicenseNo,
				p_physician_validity: payload.physicianValidity,
				p_is_active: payload.isActive,
			},
		});

		const { data } = response;
		createdPhysician = data;
	} catch (e) {
		showMessage(e);
	}
	return createdPhysician;
}

export async function updatePhysicianItems(payload) {
	let updatedPhysician;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: 'settings/physician',
			data: {
				p_physician_id: payload.physicianID,
				p_physician_prefix: payload.physicianPrefix,
				p_physician_first_name: payload.physicianFirstName,
				p_physician_middle_name: payload.physicianMiddleName,
				p_physician_last_name: payload.physicianLastName,
				p_physician_suffix: payload.physicianSuffix,
				p_physician_degree: payload.physicianDegree,
				p_physician_license_no: payload.physicianLicenseNo,
				p_physician_validity: payload.physicianValidity,
				p_is_active: payload.isActive,
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;
		updatedPhysician = data;
	} catch (e) {
		showMessage(e);
	}

	return updatedPhysician;
}

export async function applySorting(payload) {
	let sortResponse;
	const url = `settings/physiciansorting`;

	try {
		const content = {
			method: API_PUT_METHOD,
			url,
			data: {
				p_physician_sorting_array: JSON.stringify(payload)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		sortResponse = data;

		// Show success message from API response
		if (data && data.STATUSCODE === 200 && data.MESSAGE) {
			Message.success({ message: data.MESSAGE });
		}
	} catch (error) {
		showMessage(error);
	}

	return sortResponse;
}
